import { DiscountType } from 'consts/newReservationTypes/discountConstants';

export const discountValueDropdownSign = (discountType: string) => {
  let symbolOnRight = { symbol: '', placeholder: '' };
  if (discountType === DiscountType.POP) {
    symbolOnRight = { symbol: '%', placeholder: '' };
  } else if (discountType === DiscountType.DAN) {
    symbolOnRight = { symbol: 'DANA', placeholder: '' };
  } else if (discountType === DiscountType.FIX) {
    symbolOnRight = { symbol: 'EUR', placeholder: '__,__' };
  }

  return symbolOnRight;
};
